import { useAtomValue, useSetAtom } from 'jotai'
import { FC, useMemo } from 'react'
import { addPhaseAtom, phasesAtom } from '../../atoms/reviewPricing.atoms'
import { AddButton } from '@sequencehq/core-components'

export const AddPhaseButton: FC = () => {
  const addPhase = useSetAtom(addPhaseAtom)
  const phases = useAtomValue(phasesAtom)

  const isDisabled = useMemo(() => {
    const finalPhase = phases.at(-1)
    if (!finalPhase) return false

    if (finalPhase.duration === 'OPEN_ENDED') return true

    if (!finalPhase.allPrices.length) return true

    return false
  }, [phases])

  return (
    <AddButton
      data-testid="reviewPricing.addPhase"
      onClick={() => {
        addPhase()
      }}
      text="Add Phase"
      isDisabled={isDisabled}
    />
  )
}
